import { Injectable } from '@angular/core';
import { combineLatest, map, Observable, take } from 'rxjs';
import { PageGridContainer, PageStatusRequest } from './content-page-grid.model';
import { ContentPageGridAdapter } from './content-page-grid.adapter';
import { OccConfig } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class ContentPageGridService {
  constructor(
    private contentPageGridAdapter: ContentPageGridAdapter,
    private occConfig: OccConfig,
  ) {}

  getPage(pageIDorLabel: string): Observable<PageStatusRequest> {
    return this.contentPageGridAdapter.getPage(pageIDorLabel);
  }

  normalize(data: any): Observable<PageGridContainer> {
    const cards$: Observable<any>[] =
      (data.cards || ``).split(` `)?.map((cmsPageID: string) => this.getPage(cmsPageID)) || [];

    return combineLatest(cards$).pipe(
      take(1),
      map(cmsPages => {
        return {
          line1: data.line1.toString() || '',
          line2: data.line2.toString() || '',
          itemPerLine: parseInt(data.itemPerLines),
          itemPerPage: parseInt(data.itemPerPage),
          pages: (cmsPages || [])
            .map((page: PageStatusRequest) => page.page)
            .filter(page => page !== undefined)
            .map(page => {
              const _previewImage = page?.previewImage;
              return {
                ...page,
                ...{
                  previewImage: {
                    ..._previewImage,
                    ...{
                      url: (this.occConfig.backend?.occ?.baseUrl || '') + (_previewImage?.url || ''),
                    },
                  },
                },
              };
            }),
        };
      }),
    );
  }
}
